// import React from 'react';
// import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

// const Pagination = ({
//   previousPage,
//   nextPage,
//   canPreviousPage,
//   canNextPage,
//   pagination
// }) => {
//   return (
//     <div className="pagination mt-4 items-center flex justify-center">
//       <button
//         onClick={previousPage}
//         className={`border border-black rounded-lg px-1 ${canPreviousPage ? "bg-bgclr4 text-white" : "bg-gray-300 text-gray-500"}`}
//         disabled={!canPreviousPage}
//       >
//         <MdKeyboardArrowLeft size={25} />
//       </button>
//       <span className="mx-3">
//         Page{" "}
//         <strong>
//           {pagination.page} of {pagination.totalPages}
//         </strong>
//       </span>
//       <button
//         onClick={nextPage}
//         className={`border border-black rounded-lg px-1 ${canNextPage ? "bg-bgclr4 text-white" : "bg-gray-300 text-gray-500"}`}
//         disabled={!canNextPage}
//       >
//         <MdKeyboardArrowRight size={25} />
//       </button>
//     </div>
//   );
// };

// export default Pagination;


import React from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

const Pagination = ({
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pagination = { page: 1, totalPages: 1 }
}) => {
  const { page, totalPages } = pagination;
  return (
    <div className="md:py-16 md:mt-0 mt-5 items-center flex justify-center">
      <button
        onClick={previousPage}
        className={`border border-black text-gray-200 rounded-lg px-1 ${canPreviousPage ? "bg-gray-700" : "bg-gray-400"}`}
        disabled={!canPreviousPage}
      >
        <MdKeyboardArrowLeft size={45} />
      </button>
      <span className="mx-3">
        Page{" "}
        <strong>
          {page} of {totalPages}
        </strong>
      </span>
      <button
        onClick={nextPage}
        className={`border border-black text-gray-200 rounded-lg px-1 ${canNextPage ? "bg-gray-700" : "bg-gray-400"}`}
        disabled={!canNextPage}
      >
        <MdKeyboardArrowRight size={45} />
      </button>
    </div>
  );
};

export default Pagination;

export const Pagination2 = ({
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  pagination = { page: 1, totalPages: 1 }
}) => {
  const { page, totalPages } = pagination;
  return (
    <div className="md:py-5 md:mt-0 mt-5 items-center flex justify-center">
      <button
        onClick={previousPage}
        className={`border border-black text-gray-200 rounded-lg px-0.8 ${canPreviousPage ? "bg-gray-700" : "bg-gray-400"}`}
        disabled={!canPreviousPage}
      >
        <MdKeyboardArrowLeft size={30} />
      </button>
      <span className="mx-3">
        Page{" "}
        <strong>
          {page} of {totalPages}
        </strong>
      </span>
      <button
        onClick={nextPage}
        className={`border border-black text-gray-200 rounded-lg px-0.8 ${canNextPage ? "bg-gray-700" : "bg-gray-400"}`}
        disabled={!canNextPage}
      >
        <MdKeyboardArrowRight size={30} />
      </button>
    </div>
  );
};

